__webpack_require__.p = "/resources/_next/";